module.exports = __webpack_public_path__ + "static/media/ic-social-facebook.8f73e178.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-social-facebook.svg
// module id = 669
// module chunks = 14